{
  "messages": {
    "networkError": "發生網路錯誤。如果問題持續發生，請與我們聯絡。",
    "appointmentUpdatedValidationFailed": "預約已更新，但未通過外部驗證。",
    "appointmentCreatedValidationFailed": "預約已建立，但未通過外部驗證。",
    "validationErrorDetail": "<br /> 驗證錯誤：{error}"
  },
  "titles": {
    "warehouseRuleFailed": "未符合倉庫規則",
    "validationServerError": "驗證伺服器錯誤",
    "appointmentUpdatedWithValidationError": "預約已更新，但有驗證錯誤",
    "appointmentCreatedWithValidationError": "預約已建立，但有驗證錯誤"
  }
}
